import { gql, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import {
  getRandomColor,
  prepareChartDataOne,
  prepareChartDataTwo,
  prepareChartDataForAppDownloadsTwo,
  prepareChartDataForAppDownloadsOne,
  processDownloadData,
} from "./prepareChartData";
import ChartAndTable from "./ChartAndTable";
import { Loading } from "../../Components";
import RefreshIcon from "./RefreshIcon";
import "./Dashboard.scss";
const AppDownloadsQuery = gql`
  query Query {
    GetAppDownloads
  }
`;

const AppDownloads = () => {
  const Key = "User_Activity";
  const [theme, setThemeOption] = useState("Theme1");
  const [colors, setColors] = useState({});
  const [time, setTime] = useState(0);
  const [isActive, setIsActive] = useState(true);
  const [TableData, setTableData] = useState([]);
  const [chartData, setChartData] = useState({});
  const [maxNumber, setMaxNumber] = useState(10000);
  const [options, setOption] = useState({});
  const [colAddition, setColAddition] = useState([]);

  const { data, loading, error, refetch } = useQuery(AppDownloadsQuery, {
    context: { headers: { "X-GraphQL-Server": "secondary" } },
    notifyOnNetworkStatusChange: true,
  });

  useEffect(() => {
    if (data?.GetAppDownloads) {
      const { updatedData, ColAddition } = processDownloadData(data?.GetAppDownloads);
      setTableData(updatedData);
      setColAddition(ColAddition);
    }
  }, [data]);
  console.log(TableData);
  useEffect(() => {
    if (data?.GetAppDownloads) {
      let preparedData;
      if (theme === "Theme1") {
        preparedData = prepareChartDataForAppDownloadsOne(data?.GetAppDownloads, colors);
      } else {
        preparedData = prepareChartDataForAppDownloadsTwo(data?.GetAppDownloads, "#00684a", "Total App Downloads");
      }
      setChartData(preparedData);
      const max = preparedData.datasets?.reduce((max, dataset) => Math.max(max, ...dataset.data), 0) || 0;
      setMaxNumber(max + max * 0.1);
    }
  }, [data, colors, theme]);

  useEffect(() => {
    const options1 = {
      responsive: true,
      plugins: {
        legend: { position: "top" },
        title: { display: false, text: "App Downloads" },
      },
      scales: {
        x: {
          reverse: true,
          title: { display: true, text: "Date" },
          ticks: { maxRotation: 90, minRotation: 90, autoSkip: false },
        },
        y: { min: 0, max: maxNumber, ticks: { stepSize: 10 }, title: { display: true, text: "Download Count" } },
      },
    };

    const options2 = {
      responsive: true,
      plugins: {
        legend: { position: "top" },
        title: { display: false, text: "App Download" },
        tooltip: {
          callbacks: {
            label: function (context) {
              return context.dataset.label + " : " + context.parsed.y;
            },
            afterBody: function (tooltipItems) {
              if (!tooltipItems.length || !chartData?.tooltips) return "";

              const tooltipIndex = tooltipItems[0]?.dataIndex;
              const details = chartData?.tooltips[tooltipIndex];

              return details ? details : [];
            },
          },
        },
      },
      scales: {
        x: {
          reverse: true,
          title: { display: true, text: "Date" },
          ticks: { maxRotation: 90, minRotation: 90, autoSkip: false, stepSize: 1 },
        },
        y: {
          beginAtZero: true,
          min: 0,
          max: maxNumber,
          ticks: { stepSize: 10 },
          title: { display: true, text: "Download Count" },
        },
      },
    };
    setOption(theme === "Theme1" ? options1 : options2);
  }, [theme, maxNumber]);

  if (loading) {
    return <Loading />;
    // return <div></div>;
  }

  if (error) {
    return <p>Error: {error.message}</p>;
  }

  return (
    <>
      <div className="title_With_Loading_Logo">
        <div className="load-post-title">Load Post By Erp User</div>
        <div className="load-post-logo">
          <RefreshIcon handleRefetch={refetch} loading={loading} />
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div style={{ marginLeft: "1%" }}>
          <input
            type="radio"
            name="themeOptionForAppDownloading"
            value="Theme1"
            checked={theme === "Theme1"}
            onChange={() => setThemeOption("Theme1")}
          />
          Theme1
          <input
            type="radio"
            name="themeOptionForAppDownloading"
            value="Theme2"
            checked={theme === "Theme2"}
            onChange={() => setThemeOption("Theme2")}
          />
          Theme2
        </div>
        <div style={{ marginLeft: "5%" }}>
          {/* <RefreshButton
            isRefetching={isRefetching}
            onRefresh={handleRefresh}
            time={{ hours: Math.floor(time / 3600), minutes: Math.floor((time % 3600) / 60), seconds: time % 60 }}
          /> */}
        </div>
      </div>
      <ChartAndTable
        chartData={chartData}
        options={options}
        data={TableData}
        error={error}
        tableKey={Key}
        isLoading={loading}
        colAddition={colAddition}
      />
    </>
  );
};

export default AppDownloads;
